import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_SCC_API } from '@/service'

const api = {
  userInfo: PREFIX_SCC_API + 'fchild/worker/queryWorkerInfoDetail.do',
  credentials: `${utils.hostname(
    'subscriber'
  )}/subscriber-web/schedual/getCredentials.do`,
  cmt: `${utils.hostname('cmt')}/v1`, // ${this.plat}/comment/search/${obj}?${$query}
  addFocusUrl: `${utils.hostname('apidyn')}/api/v1/users/addFollow`,
  deleteFocusUrl: `${utils.hostname('apidyn')}/api/v1/users/deleteFollow`,
  shequUserInfo: `${utils.hostname('apidyn')}/api/v1/users/userInfo`,
  getServiceInfo: PREFIX_SCC_API + 'fchild/worker/queryWorkerSpuList.do',
  experience: `${utils.hostname('apidyn')}/api/v1/feeds/columnTagUserLastFeed`,
  experience_list: `${utils.hostname('apidyn')}/api/v1/feeds/columnTagFeeds`,
  // signList: `${utils.hostname('subscriber')}/subscriber-web/crafts/getSignInfos.do`,
  ask: `${utils.hostname('ask')}/api/v1/users/answers`,
  // shoppingList: `${utils.hostname('shoppinglist')}/shoppinglist/QueryShoppingList`,
  bbsList: `${utils.hostname('apidyn')}/api/v1/feeds/userFeeds`,
  setAdviser: `${utils.hostname('user')}/user/ModifyParentingAdviser`,
  shequUserInfoPlus: `${utils.hostname('apidyn')}/api/v1/users/userInfoPlus`,
  // shequUserInfoPlus: '/api/v1/users/userInfo',
  getUserInfoFromUser: `${utils.hostname('user')}/user/GetUserInfo`,
  getUserSimpleInfo: PREFIX_SCC_API + 'fchild/worker/queryWorkerInfoSimple.do',
  getStaffDetail: `${utils.hostname(
    'svc-aggregation'
  )}/svc-aggregation/staff/staffDetail.do`,
  getBuswxscene: `${utils.hostname('cms')}/publish/998/buswxscene.json`
}

export default {
  async getUserSimpleInfo({ commit }, { uid, code }) {
    // uid, code 二选一
    try {
      const query = queryString.stringify({
        uid,
        code
      })
      const employe_res = await fetch(`${api.getUserSimpleInfo}?${query}`)
      const employeJSON = await employe_res.json()
      if (employeJSON.code === '1') {
        return employeJSON || {}
      }
      return employeJSON
    } catch (e) {
      console.log(e)
    }
  },
  async getUserInfoFromUser(
    { commit },
    { uid, skey, visitkey, padetail, pregnant }
  ) {
    try {
      const query = queryString.stringify({
        uid,
        skey,
        visitkey,
        padetail,
        pregnant
      })
      const user_res = await fetch(`${api.getUserInfoFromUser}?${query}`)
      const userJson = await user_res.json()
      if (userJson.errno === 0) {
        return userJson.data || {}
      }
      return {}
    } catch (e) {
      console.log(e)
    }
  },
  async getUserInfoData({ commit }, { uid, cityId = '', memberUid }) {
    try {
      const param = {
        uid,
        r: new Date().getTime(), // 接口不需要此参数，仅为避免浏览器返回跨域
        memberUid
      }
      if (cityId) {
        param.cityId = cityId
      }
      console.log('param', cityId)
      const query = queryString.stringify(param)
      const user_res = await fetch(`${api.userInfo}?${query}`)
      const userJson = await user_res.json()
      if (userJson.code === '1') {
        commit('setUserInfo', userJson.data || {})
      }
      return userJson
    } catch (e) {
      console.log(e)
    }
  },
  async getServiceInfoData(
    { commit },
    { uid, pageIndex, pageSize, workerCode }
  ) {
    try {
      const query = queryString.stringify({
        uid,
        pageIndex,
        pageSize,
        workerCode
      })
      const service_res = await fetch(`${api.getServiceInfo}?${query}`)
      const serviceJson = await service_res.json()
      let services = []
      if (serviceJson.code * 1 === 1) {
        services = serviceJson.data || []
        commit('setUserServiceList', services)
      } else {
        throw new Error(serviceJson.code)
      }
      return serviceJson
    } catch (e) {
      console.log(e)
    }
  },
  async getCertificateData({ commit }, { uid }) {
    try {
      const query = queryString.stringify({
        uid
      })
      const credentials_res = await fetch(`${api.credentials}?${query}`)
      const credentialsJson = await credentials_res.json()
      return credentialsJson
    } catch (e) {
      console.log(e)
    }
  },
  // 获取泛育儿顾问评价列表
  async getEvaluatePage(
    { commit, state },
    { extend, page, size, show_user, show_reply }
  ) {
    try {
      const query_param = {
        extend,
        page,
        size,
        show_user,
        show_reply
      }
      const query = queryString.stringify(query_param)
      const evaluate_res = await fetch(
        `${api.cmt}/czjyuer/comment/search/extend?${query}`
      )
      const evaluateJson = await evaluate_res.json()
      let evaluates = []
      if (evaluateJson.code === 1001) {
        if (page === 1) {
          commit('resetEvaluatesList')
        }
        evaluates = evaluateJson.data.list || []
        commit('setEvaluatesList', evaluates)
      } else {
        throw new Error(evaluateJson.code)
      }
      return evaluateJson
    } catch (e) {
      throw new Error(e)
    }
  },
  // 从社区获取当前用户与被操作人的关注关系
  async getUserInfoFromShequ(store, { uid, to_uid }) {
    try {
      const query_param = {
        uid,
        to_uid,
        has_relation: 1
      }
      const query = queryString.stringify(query_param)
      const user = await fetch(`${api.shequUserInfo}?${query}`, {
        credentials: 'include'
      })
      const user_json = await user.json()
      return user_json
    } catch (e) {
      console.log(e)
    }
  },
  async getUserInfoPlusFromShequ(store, { to_uid }) {
    try {
      const query_param = {
        to_uid
      }
      const query = queryString.stringify(query_param)
      const user = await fetch(`${api.shequUserInfoPlus}?${query}`, {
        credentials: 'include'
      })
      const user_json = await user.json()
      return user_json
    } catch (e) {
      console.log(e)
    }
  },
  /* 获取企微员工详情 */
  async getStaffDetail(store, { uid, to_uid, skey }) {
    let wxChannel = 'kwtopcontacts'
    try {
      const res = await fetch(`${api.getBuswxscene}`)
      const { data: buswxscene = {} } = await res.json()
      const scene =
        Array.isArray(buswxscene.scene) &&
        buswxscene.scene.find(item => {
          return item.scenetype == 'topcontacts'
        })
      wxChannel = scene ? scene.wxchannel : wxChannel
    } catch (e) {
      console.log(e)
    }
    try {
      const query_param = {
        uid,
        staffUid: to_uid,
        skey,
        source: 0,
        wxChannel
      }
      const query = queryString.stringify(query_param)
      const res = await fetch(`${api.getStaffDetail}?${query}`, {
        credentials: 'include'
      })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  // 关注
  async doFollow({ commit }, { follow_id }) {
    try {
      const query_param = {
        follow_id
      }
      const query = queryString.stringify(query_param)
      const res = await fetch(`${api.addFocusUrl}?${query}`, {
        credentials: 'include'
      })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  // 取消关注
  async deleteFollow(store, { follow_id }) {
    try {
      const query_param = {
        follow_id
      }
      const query = queryString.stringify(query_param)
      const res = await fetch(`${api.deleteFocusUrl}?${query}`, {
        credentials: 'include'
      })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  async getYuerExperience({ commit }, { to_uid, column_tag_id }) {
    try {
      const query_param = {
        to_uid,
        column_tag_id
      }
      const query = queryString.stringify(query_param)
      const res = await fetch(`${api.experience}?${query}`, {
        credentials: 'include'
      })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  async getExperienceList(
    { commit },
    { to_uid, page, limit_num, column_tag_id, time_stamp }
  ) {
    try {
      const query = queryString.stringify({
        to_uid,
        // page,
        limit_num,
        column_tag_id,
        time_stamp
      })
      const experience = await fetch(`${api.experience_list}?${query}`, {
        credentials: 'include'
      })
      const experienceJson = await experience.json()
      if (experienceJson.code === 1001 && experienceJson.data) {
        if (page === 1) {
          commit('resetUserExperience')
        }
        commit('setUserExperience', experienceJson.data || [])
      }
      return experienceJson
    } catch (e) {
      console.log(e)
    }
  },
  // async getSignList({ commit }, { code, pageNo, pageSize }) {
  //     try {
  //         const query = queryString.stringify({
  //             code,
  //             pageNo,
  //             pageSize
  //         })
  //         const res = await fetch(`${api.signList}?${query}`)
  //         const json = await res.json()
  //         return json
  //     } catch (e) {
  //         console.log(e);
  //     }
  // },
  async getAnswers({ commit }, { uid, page, limit_num }) {
    try {
      const query = queryString.stringify({
        to_uid: uid,
        page,
        limit_num
      })
      const res = await fetch(`${api.ask}?${query}`, {
        credentials: 'include'
      })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  // async getShoppingList({ commit }, { uid }) {
  //     try {
  //         const query = queryString.stringify({
  //             uid,
  //             qtype: 2,
  //             startidx: 0,
  //             pagesz: 10,
  //             random: 8
  //         })
  //         const res = await fetch(`${api.shoppingList}?${query}`)
  //         const json = await res.json()
  //         return json
  //     } catch (e) {
  //         console.log(e);
  //     }
  // },
  async getBBSList({ commit }, { to_uid, limit_num }) {
    try {
      const query_param = {
        to_uid,
        limit_num
      }
      const query = queryString.stringify(query_param)
      const res = await fetch(`${api.bbsList}?${query}`, {
        credentials: 'include'
      })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  async setModifyBasicUserInfo(store, { uid, skey, pauid, source }) {
    try {
      const param = {
        uid,
        skey,
        pauid,
        source
      }
      const query = queryString.stringify(param)
      const res = await fetch(`${api.setAdviser}?${query}`)
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  }
}
